import Handlebars from 'handlebars/dist/handlebars.runtime';
        const templateFunction = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "    <li class=\"active-filter\">\n        <button class=\"active-filter__remove-btn\" data-remove-filter=\""
    + alias2(alias1((depth0 != null ? depth0.filterId : depth0), depth0))
    + "\" aria-describedby=\"remove-filter-description\">\n            <svg class=\"icon--close-btn\">\n                <use xlink:href=\"../sprite.svg#close\"></use>\n            </svg> "
    + alias2(alias1((depth0 != null ? depth0.label : depth0), depth0))
    + "\n        </button>\n    </li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<ul class=\"active-filters\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.activeFilters : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</ul>";
},"useData":true});
        export default templateFunction;